import React from 'react';
import { UserTable } from '$cmp/users/userTable';

export const UsersRoute: React.FunctionComponent = () => <UserTable />;
